import HTMLReactParser from 'html-react-parser';
import sanitizeHTML from './purify';
import parserOptions, { parsedCollection, initCollection } from './parse';

const sanitizeHeader = (htmlString, parser = HTMLReactParser.default) => 
{ 
    const sanitized = sanitizeHTML(htmlString);
    initCollection();

    return {
        parsed: parser(sanitized, parserOptions),
        parsedCollection
    };
};

export default sanitizeHeader;